import React from 'react'
import './Header.scss';
import NftGallery from './NftGallery';
import NftWinners from './NftWinners';
import { useIsDesktop } from '../../../../hooks/index';
import ClaimCountdown from '../ClaimCountdown/ClaimCountdown';

export const Header = () => {
    const isDesktop = useIsDesktop();

    return (
        <div className="header-component">
            <div className="header-component__container">
                <img src={require('../../../../images/icons/viper-icon.svg').default} alt="viper"/>

                <div>
                    <h1>COTI NFT GAME<b>Winners</b></h1>
                </div>
                <NftWinners/>
                <ClaimCountdown />
                
                <NftGallery />
            </div>

            {isDesktop ? 
                <img src={require('../../../../images/layout/stripe-up.svg').default} alt="stripe" /> : 
                <img src={require('../../../../images/layout/stripe-up-mobile.svg').default} alt="stripe" /> }
        </div>
    )
}

export default Header;